module.exports = __webpack_public_path__ + "img/successicon.b0774bf5.svg";